export default {
  ratePlanType: {
    STANDARD: 'Standard',
    BAR: 'Bestpreis',
    CORPORATE: 'Unternehmen',
    MEMBER: 'Mitglied',
    PACKAGE: 'Paket',
    PROMOTIONAL: 'Aktion',
    OTA: 'OTA',
    WHOLESALE: 'Großhandel',
    NEGOTIATED: 'Vereinbart',
    MIXED: 'Kombinierter Tarif',
  },
} as const;
